import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook--sprite",
  "use": "facebook--sprite-usage",
  "viewBox": "0 0 12 24",
  "content": "<symbol viewBox=\"0 0 12 24\" id=\"facebook--sprite\">\n<path d=\"M3 8H0V12H3V24H8V12H11.642L12 8H8V6.333C8 5.378 8.192 5 9.115 5H12V0H8.192C4.596 0 3 1.583 3 4.615V8Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol